import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'
import LoadTop from './components/Functionals/LoadTop'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <BrowserRouter>
    <LoadTop />
    <App />
  </BrowserRouter>
)
reportWebVitals()